<script lang="ts">
  interface Props {
    variant?: "primary" | "secondary";
    size?: "xs" | "S" | "M" | "L";
    class?: string;
    children?: import("svelte").Snippet;
    id?: string;
  }

  let { variant = "secondary", size = "S", class: className, children, id }: Props = $props();

  // Size must be a prop, not a class override: two text-* utilities on the same
  // element resolve by CSS emission order, which is scan-order-dependent in this
  // Tailwind JIT setup — a class="text-M" override can silently lose to text-S.
  const sizeClasses: Record<NonNullable<Props["size"]>, string> = {
    xs: "text-xs",
    S: "text-S",
    M: "text-M",
    L: "text-L",
  };
</script>

<span
  {id}
  class="{className} {sizeClasses[size]} block {variant == 'primary'
    ? 'text-Neutral900'
    : 'text-Neutral800'} "
  >{@render children?.()}</span
>
